export enum ReclassifyBatchTypes {
	CurrentYearSameFund = 1,
	CurrentYearRefund = 2,
	PriorYearRefund = 3,
	InstructionalPersonalChanges = 4,
	TransportationRefund = 5,
	PriorYearTransportationRefund = 6,
	PenaltyPayments = 7,
}
